import { Box, StatusIndicator } from '@amzn/awsui-components-console';
import { getConfidenceLevel, getConfidenceIndicatorType } from '../utils/evaluationHelpers';

interface ConfidenceBadgeProps {
  confidence: number | undefined | null;
}

export function ConfidenceBadge({ confidence }: ConfidenceBadgeProps): React.JSX.Element {
  const level = getConfidenceLevel(confidence);
  if (level === 'none') {
    return <Box color="text-status-inactive">N/A</Box>;
  }
  const type = getConfidenceIndicatorType(level);
  const pct = Math.round(confidence! * 100);
  return <StatusIndicator type={type}>{pct}%</StatusIndicator>;
}
